/* eslint-disable react/jsx-props-no-spreading */
import { useState } from 'react';
import { View, type Props } from 'components/Favorite/components/View';
import { useBookmark, type Arg } from '../../hooks/useBookmark';

/**
 * FavoriteButtonのProps
 */
export interface FavoriteButtonProps extends Omit<Props, 'state'>, Arg {}

/** 求人詳細用気になるボタン */
export const FavoriteButton = (props: FavoriteButtonProps) => {
  const {
    jid,
    isBookmarked,
    wapid,
    onClickFavorite,
    withoutBalloon,
    ...restProps
  } = props;
  const [isClicked, setIsClicked] = useState(false);
  const { bookmarkState, saveBookmark } = useBookmark({
    jid,
    isBookmarked,
    wapid,
    onSuccess: () => {
      setIsClicked(true);
    },
  });

  return (
    <View
      {...restProps}
      state={bookmarkState}
      onClickFavorite={(event) => {
        saveBookmark();
        onClickFavorite?.(event);
      }}
      // 実際に押下されていないボタンではバルーンを表示しない
      withoutBalloon={withoutBalloon || !isClicked}
    />
  );
};
